<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="menu-layout">
      <div class="layout-strip">
        <draggable v-if="showEditLayoutButton" v-model="myLayouts" tag="ul" draggable=".layout" :delay="100" :delayOnTouchOnly="true" :componentData="{ attrs: { class: 'layout-selector' }}" v-on:change="layoutOrderChanged">
          <template v-for="layout in myLayouts">
            <li class="layout" v-if="parseInt(layout.id)"><a :class="'layout-option' + (activeLayout.id === layout.id ? ' active' : '')" v-on:click="setActiveLayout(layout.id)">{{ layout.name }}<i class="fa fa-fw fa-pencil" v-if="showEditLayoutButton" v-on:click.stop="editLayout(layout)" style="padding-left: 5px"></i></a></li>
            <li v-else-if="layout.id === 'add' && showAddLayoutButton"><a class="layout-option" v-on:click="addLayout">{{ _('New section') }}<i class="fa fa-fw fa-plus" style="padding-left: 5px"></i></a></li>
            <li v-else-if="layout.id === 'edit' && canSetEditMode"><a class="layout-option" v-on:click="toggleEditMode"><i class="fa fa-fw fa-cog"></i></a></li>
          </template>
        </draggable>
        <ul v-else class="layout-selector">
          <li v-for="layout in layouts"><a :class="'layout-option' + (activeLayout.id === layout.id ? ' active' : '')" v-on:click="setActiveLayout(layout.id)"><i v-if="layout.icon" :class="'fa fa-fw fa-' + layout.icon" style="margin-left: -2px; margin-right: 5px"></i>{{ layout.name }}<i class="fa fa-fw fa-pencil" v-if="showEditLayoutButton" v-on:click.stop="editLayout(layout)" style="padding-left: 5px"></i></a></li>
          <li v-if="showAddLayoutButton"><a class="layout-option" v-on:click="addLayout">{{ _('New section') }}<i class="fa fa-fw fa-plus" style="padding-left: 5px"></i></a></li>
          <li v-if="canSetEditMode"><a class="layout-option" v-on:click="toggleEditMode"><i class="fa fa-fw fa-cog"></i></a></li>
        </ul>
        <select class="form-control" v-model="selectedVersion" v-if="false">
          <option v-for="ver in versions" :value="ver">{{ getVersionName(ver) }}</option>
        </select>
      </div>
      <div class="menu-form">
        <div class="row">
          <div class="col-xs-12">
            <h3>{{ _('Menu') }}</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>{{ _('Value card') }}</label>
              <div class="input-group">
                <input type="text" class="form-control manual-input" v-model="code" v-on:keyup="codeKeyUp" :placeholder="_('Use a code')" />
                <span class="input-group-btn">
                  <button class="btn btn-primary" v-on:click="applyCode">{{ _('OK') }}</button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <br/><br/><br/><hr>
            <button class="btn btn-danger" v-on:click="logout"><span class="fa fa-fw fa-sign-out"></span> {{ _('Logout') }}</button>
            <button class="btn btn-default" v-on:click="reloadApp"><i class="fa fa-fw fa-arrows-rotate"></i> {{ _('Reload') }}</button>
            <button class="btn btn-info" v-on:click="enableFullscreen"><i class="fa fa-fw fa-arrows-alt"></i> {{ _('Full screen') }}</button>
            <button class="btn btn-default" v-on:click="exitFullscreen"><i class="fa fa-fw fa-arrows"></i> {{ _('Exit full screen') }}</button>
          </div>
          <div class="col-xs-12">
          <br/>
          <hr/>
          <p>{{ _('Identifier') }}: <strong>{{ clientid }}</strong></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import components from '~/lib/components'
import layouts from '~/lib/layouts'
import permissions from '~/lib/permissions'
import { reloadApp } from '~/lib/sessionRecovery'

export default {
  data () {
    return {
      myLayouts: [],
      code: ''
    }
  },
  mixins: [components, layouts, permissions],
  computed: {
    ...mapGetters(['layouts', 'editMode']),
    versions () {
      return this.settings && this.settings.versions ? this.settings.versions.split(';') : []
    },
    selectedVersion: {
      get () {
        return this.version
      },
      set (newValue) {
        this.setVersion(newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'setVersion',
    ]),
    async layoutOrderChanged () {
      const data = {
        id: null,
        layout: null,
        layouts: null
      }
      const layouts = []
      for (let i = 0; i < this.myLayouts.length; i++) {
        const ml = this.myLayouts[i]
        if (i === 0) {
          data.layout = ml.id
        } else if (parseInt(ml.id)) {
          layouts.push(ml.id)
        }
      }
      data.layouts = layouts.join(';')
      // The non-editmode layout-strip renders from the store's `layouts`
      // getter, while the draggable editmode strip renders from local
      // `myLayouts`. Update the store too so leaving edit mode doesn't
      // revert the strip back to the stale, pre-reorder order.
      this.updateLayoutsOrder(this.myLayouts.filter(ml => ml.id !== 'add').map(ml => ml.id))
      this.reorderLayouts(data)
    },
    async logout () {
      try {
        await this.$store.dispatch('logout')
      } catch (e) {
      }
    },
    reloadApp,
    enableFullscreen () {
      this.requestFullscreen(document.documentElement)
    },
    requestFullscreen (el) {
      if (el.requestFullscreen) {
        el.requestFullscreen()
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen()
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen()
      } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen()
      } else {
        // Fallback
        console.log('Fullscreen API is not supported.')
      }
    },
    exitFullscreen () {
      if (!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
        return
      }
      const exit = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen
      if (exit) {
        Promise.resolve(exit.call(document)).catch(() => {})
      } else {
        // Fallback
        console.log('Fullscreen API is not supported.')
      }
    },
    applyCode () {
      if (!this.code) {
        return
      }
      let codeStr = this.code
      if (!codeStr.match(/^http/)) {
        codeStr = codeStr.replace(/\-/g, '')
      }
      if (!codeStr.match(/^http/) && !codeStr.match(/\//)) {
        codeStr = this.baseDomain + this.shopId + '/qr/V' + codeStr
      }
      this.EventBus.$emit('manualScan', { code: codeStr })
      this.code = ''
    },
    codeKeyUp (event) {
      if (event) {
        if (event.keyCode === 13 || event.key === 'Enter') {
          this.applyCode()
        }
      }
    }
  },
  watch: {
    components: {
      deep: true, 
      handler (newValue) {
        this.myLayouts = [...newValue, { id: 'add' }, { id: 'edit' }]
      }
    }
  },
  created () {
    this.myLayouts = [...this.layouts, { id: 'add' }, { id: 'edit' }]
  }
}

</script>